/**
 * Format a date string with different styles.
 * @param {string} dateString
 * @param {'short'|'medium'|'long'|'compact'} [style='short']
 */
export const formatDate = (dateString, style = 'short') => {
  if (!dateString) return '';
  const date = new Date(dateString);

  switch (style) {
    case 'long':
      // "Saturday, February 7, 2026"
      return date.toLocaleDateString('en-US', {
        weekday: 'long',
        month: 'long',
        day: 'numeric',
        year: 'numeric',
        timeZone: 'UTC'
      });
    case 'medium':
      // "Sat, Feb 7, 2026"
      return date.toLocaleDateString('en-US', {
        weekday: 'short',
        month: 'short',
        day: 'numeric',
        year: 'numeric',
        timeZone: 'UTC'
      });
    case 'compact':
      // "Sat, Feb 7" (no year)
      return date.toLocaleDateString('en-US', {
        weekday: 'short',
        month: 'short',
        day: 'numeric',
        timeZone: 'UTC'
      });
    case 'short':
    default:
      // "Feb 7, 2026"
      return date.toLocaleDateString('en-US', {
        month: 'short',
        day: 'numeric',
        year: 'numeric',
        timeZone: 'UTC'
      });
  }
};

/**
 * Format a date as relative time ago (e.g. "5m ago", "2h ago", "3d ago").
 */
export const formatTimeAgo = (date) => {
  if (!date) return '';

  const now = new Date();
  const then = date instanceof Date ? date : new Date(date);
  const diffMs = now - then;
  const diffMins = Math.floor(diffMs / 60000);
  const diffHours = Math.floor(diffMs / 3600000);
  const diffDays = Math.floor(diffMs / 86400000);

  if (diffMins < 1) return 'Just now';
  if (diffMins < 60) return `${diffMins}m ago`;
  if (diffHours < 24) return `${diffHours}h ago`;
  if (diffDays === 1) return 'Yesterday';
  return `${diffDays}d ago`;
};

/**
 * Calculate countdown days to a race date.
 * @returns {{ days: number, isPast: boolean }}
 */
export const calculateCountdown = (dateString) => {
  // Parse as UTC to avoid timezone offset shifting the date
  const raceDate = new Date(dateString);
  const today = new Date();
  today.setUTCHours(0, 0, 0, 0);
  raceDate.setUTCHours(0, 0, 0, 0);

  const diffTime = raceDate - today;
  const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

  if (diffDays < 0) {
    return { days: Math.abs(diffDays), isPast: true };
  }
  return { days: diffDays, isPast: false };
};
